/* eslint-disable prettier/prettier */
/* eslint-disable prefer-template */
/* eslint-disable prettier/prettier */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-string-refs */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/extensions */
/* eslint-disable import/order */
/* eslint-disable react/jsx-curly-brace-presence */
import React from "react";
import "./PlayerReport.css"; // Import the CSS file
import { useTranslation } from "react-i18next";
import {
  MailIcon,
  PrintIcon,
  Download,
} from "../../Constants/assets";
import styled from "styled-components";

const GameSummaryComponent = styled.div`
  text-decoration: underline;
  color: ${(props) => props.theme.colors.darkGreen};
  cursor: pointer;
  width: fit-content;
`;

const TopIcons = styled.div`
  width: 5%;
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  justify-content: space-between;
`;
const PrintButton = styled.button`
  background-color: transparent;
  border: none;
`;

const insertVariablesToTranslation = (TranslatedComment, originalComment) => {
  if (TranslatedComment.includes("$x")) {
    const numericMatch = originalComment.match(/\d+/); // Extract numeric value
    if (numericMatch && numericMatch.length > 0) {
      TranslatedComment = TranslatedComment.replace("$x", numericMatch[0] + "$");
    }
  }
  return TranslatedComment;
};
const PlayerReport = ({
  reportJSON,
  setRef,
  playerName,
  projectName,
  initialBudget,
  gameDate,
  gameID,
  gameScore,
  initialResources,
  email,
  projectGoal,
  gameDuration,
  gameStatus,
  assistanceMode,
  actions = [],
  commentsList,
  printFormat,
  exportPDFToEmail,
  setMailed,
  setCursorType,
  downloadReportFunc,
  mailed,
  cursorType,
  setPopUp
}) => {
  const { t } = useTranslation();

  return (
    <div className="player-report-container" ref={setRef}>
      <TopIcons id="icons">
        <PrintButton
          onClick={() => {
            printFormat();
          }}
        >
          <PrintIcon
            style={{
              cursor: "pointer",
            }}
          />
        </PrintButton>
        <PrintButton
          onClick={() => {
            exportPDFToEmail();
            setMailed("disabled");
            setCursorType("no-drop");
            setTimeout(() => {
              setMailed(false);
              setCursorType("pointer");
            }, 5000);
          }}
          disabled={mailed}
        >
          <MailIcon
            style={{
              cursor: cursorType,
            }}
          />
        </PrintButton>
        <PrintButton
          onClick={() => {
            downloadReportFunc("download", reportJSON);
          }}
        >
          <Download
            style={{
              cursor: "pointer",
            }}
          />
        </PrintButton>
      </TopIcons>
      <div className="report-details-container">
        <div className="report-details-container-top row">
          <p className="report-p col-15"><strong className="report-strong">{t(`report.summary_stats.player_name`)}</strong> {reportJSON.playerFullName}</p>
          <p className="report-p col-20"><strong className="report-strong">{t(`report.summary_stats.project_name`)}</strong> {projectName}</p>
          <p className="report-p col-20"><strong className="report-strong">{t(`report.summary_stats.initial_budget`)}</strong> ${initialBudget.toLocaleString("en-US")}</p>
          <p className="report-p col-15"><strong className="report-strong">{t(`report.summary_stats.game_date`)}</strong> {reportJSON.startGameTimeAsFullUtcString}</p>
          <p className="report-p col-10"><strong className="report-strong">{t(`report.summary_stats.game_id`)}</strong> {gameID}</p>
          <p className="report-p col-10"><strong className="report-strong">{t(`report.summary_stats.game_score`)}</strong> {gameScore}</p>
        </div>
        <div className="report-details-container-bot row">
          <p className="report-p col-15"><strong className="report-strong">{t(`report.summary_stats.email`)}</strong> {email}</p>
          <p className="report-p col-20"><strong className="report-strong">{t(`report.summary_stats.project_goal`)}</strong> {projectGoal}</p>
          <p className="report-p col-20"><strong className="report-strong">{t(`report.summary_stats.initial_resources`)}</strong> {' '}
            {t('global_variables.resources.standard')}: {initialResources.Standard}, {' '}
            {t('global_variables.resources.senior')}: {initialResources.Senior}, {' '}
            {t('global_variables.resources.executive')}: {initialResources.Executive}
          </p>
          <p className="report-p col-15"><strong className="report-strong">{t(`report.summary_stats.game_duration`)}</strong> {reportJSON.gameTimerLocal}</p>
          <p className="report-p col-10"><strong className="report-strong">{t(`report.summary_stats.game_status`)}</strong> {t(`report.summary_stats.game.${gameStatus}`)}</p>
          <p className="report-p col-10"><strong className="report-strong">{t(`report.summary_stats.assistance_mode`)}</strong> {assistanceMode}</p>
        </div>
        <GameSummaryComponent id="summary-stats-enable" onClick={() => setPopUp(true)}>
          {t(`report.summary_stats.summary_stats_title`)}
        </GameSummaryComponent>
      </div>

      <table className="report-table">
        <thead>
          <tr className="report-tr">
            <th className="report-th col-5">{t("report.detailed_report.table_titles.turn")}</th>
            <th className="report-th col-5">{t("report.detailed_report.table_titles.position")}</th>
            <th className="report-th col-10">{t("report.detailed_report.table_titles.action")}</th>
            <th className="report-th col-10">{t("report.summary_stats.title")}</th>
            <th className="report-th col-5">{t("report.detailed_report.table_titles.cost")}</th>
            <th className="report-th col-15">{t("global_variables.resources.resources")}</th>
            <th className="report-th col-5 center">{t("report.detailed_report.table_titles.value")}</th>
            <th className="report-th col-5 center">{t("report.detailed_report.table_titles.progress")}</th>
            <th className="report-th col-5 center">{t("report.detailed_report.action_information.total_value")}</th>
            <th className="report-th col-5 center">{t("report.detailed_report.action_information.remaining_budget")}</th>
            <th className="report-th col-15">{t("report.summary_stats.remaining_resources_no_colon")}</th>
            <th className="report-th col-15">{t("report.detailed_report.table_titles.comments")}</th>
          </tr>
        </thead>
        <tbody>
          {actions.map((action, index) => {
            const { turnData, cardData } = action;
            const cost = Number(cardData?.costMoney ?? turnData?.costMoney)
            if (turnData.code == 21) {
              return <></>
            }
            return (
              <tr className="report-tr" key={index}>
                <td className="report-td col-5">{turnData.code == 10 ? <>
                  *
                </> : <>
                  {turnData.turnNumber}
                </>
                }</td>
                <td className="report-td col-5">{turnData.spotNumber}</td>
                <td className="report-td col-10">
                  {/* {turnData.type.replace(/-/g, " ").replace(/\b\w/g, char => char.toUpperCase())} */}
                  {turnData.code == 11 && (
                    <>
                      {t('global_variables.game_element.general_task')} #{turnData.value}
                    </>
                  )}
                  {turnData.code == 4 && (
                    <>
                      {t('global_variables.game_element.risk')} #{turnData.value}
                    </>
                  )}
                  {turnData.code == 10 && (
                    <>
                      {t('global_variables.actions.additional_resources')}
                    </>
                  )}
                  {turnData.code == 7 && (
                    <>
                      {t('global_variables.actions.additional_budget')}
                    </>
                  )}
                  {turnData.code == 2 && (
                    <>
                      {t('global_variables.game_element.planned_task')} #{turnData.value}
                    </>
                  )}
                  {turnData.code == 3 && (
                    <>
                      {t('global_variables.game_element.unplanned_task')} #{turnData.value}
                    </>
                  )}
                  {turnData.code == 5 && (
                    <>
                      {t('global_variables.game_element.constraint')} #{turnData.value}
                    </>
                  )}
                  {turnData.code == 6 && (
                    <>
                      {t('global_variables.game_element.delay')} #{turnData.value}
                    </>
                  )}
                  {turnData.code == 8 && (
                    <>
                      {t('global_variables.game_element.milestone')} #{turnData.value}
                    </>
                  )}
                  {(turnData.code == 9 || turnData.code == 13) && (
                    <>
                      {t('global_variables.game_element.gate')} #{turnData.value}
                    </>
                  )}
                </td>
                {(cardData?.type == "unplanned-task") ?
                  <td className="report-td col-10">{cardData?.name ?? cardData?.name ?? ""}</td>
                  : <td className="report-td col-10">{cardData?.taskname ?? cardData?.taskName ?? ""}</td>
                }
                <td className={`report-td col-5 ${(cost < 0) ? "cost" : ""}`}>
                  {cost.toLocaleString("en-US", { style: 'currency', currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                </td>
                <td className="report-td col-10"> {(cardData?.costResourcesNormal || cardData?.costResourcesSenior || cardData?.costResourcesExpensive) ? <>
                  {t('global_variables.resources.standard')}: {cardData?.costResourcesNormal}, {' '}
                  {t('global_variables.resources.senior')}: {cardData?.costResourcesSenior}, {' '}
                  {t('global_variables.resources.executive')}: {cardData?.costResourcesExpensive}
                </> : <>
                </>}
                </td>
                <td className="report-td col-5 center">{cardData?.earnedValue ?? 0}</td>
                <td className="report-td col-5 center">{cardData?.stepChange ?? 0}</td>
                <td className="report-td col-5 center">{turnData?.earnedValue ?? 0}</td>
                <td className="report-td col-5 remaining-budget center">${turnData?.budget?.toLocaleString("en-US")}</td>
                <td className="report-td col-10">
                  {(turnData?.regular || turnData?.senior || turnData?.expensive) && <>
                    {t('global_variables.resources.standard')}: {turnData?.regular}, {' '}
                    {t('global_variables.resources.senior')}: {turnData?.senior}, {' '}
                    {t('global_variables.resources.executive')}: {turnData?.expensive}
                  </>}
                </td>
                <td className="report-td col-10">
                  {turnData?.comment?.map((_index, commentIdx) => {
                    const findComment =
                      _index.comment_id != null && _index.comment_id !== undefined
                        ? commentsList.find(
                            (c) => Number(c.id) === Number(_index.comment_id),
                          )
                        : commentsList.find(
                            (comment) =>
                              insertVariablesToTranslation(
                                comment.value,
                                _index.value,
                              ) === _index.value,
                          );
                    if (!findComment) {
                      return (
                        <React.Fragment key={`${turnData.id}-c-${commentIdx}`}>
                          {_index.value}
                          <br />
                        </React.Fragment>
                      );
                    }
                    return (
                      <React.Fragment key={`${turnData.id}-c-${findComment.id}-${commentIdx}`}>
                        {insertVariablesToTranslation(
                          t(`report.detailed_report.comments.${findComment.id}`, {
                            findComment: findComment.id,
                          }),
                          _index.value,
                        )}
                        <br />
                      </React.Fragment>
                    );
                  }) ?? ""}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PlayerReport;
